/**
 * @ComponentFor Avensia.Common.ContentTypes.Media.ImageDataModel
 */
import React from 'react';
import { epiPropertyValue } from '@avensia/scope';
import Image from '../Image';
import ImageDataModelType from 'ContentTypes/Media/ImageData';

export default (props: ImageDataModelType) => <Image src={epiPropertyValue(props.contentLink)} />;
